module.exports = __webpack_public_path__ + "static/media/bofa_lo3_rgb_symbol.11c4cc19.svg";